import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor() { }

  gettoken(){  
    return !! sessionStorage.getItem('duplicateSession') 
    } 
}
